import styled from 'styled-components';
import { unthemed } from 'tokens';

export const BackLink = styled.button`
	display: flex;
	align-items: center;
	gap: 6px;
	background: none;
	border: none;
	color: ${(p) => p.theme.gray[600]};
	font-size: 14px;
	font-family: inherit;
	padding: 0;
	margin-bottom: 24px;

	&:hover {
		color: ${(p) => p.theme.gray[800]};
	}
`;

export const InviteRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 16px;
`;

export const InviteInput = styled.input`
	flex: 1;
	padding: 10px 14px;
	font-size: 14px;
	font-family: inherit;
	border: 1px solid ${(p) => p.theme.gray[400]};
	border-radius: 8px;
	background: ${(p) => p.theme.white};
	color: ${(p) => p.theme.gray[1000]};
	outline: none;

	&:focus {
		border-color: ${(p) => p.theme.blue[500]};
	}

	&::placeholder {
		color: ${(p) => p.theme.gray[400]};
	}
`;

export const TeamCard = styled.div`
	background: ${(p) => p.theme.gray[0]};
	border-radius: 12px;
	padding: 24px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
`;

export const MemberTable = styled.table`
	width: 100%;
	border-collapse: separate;
	border-spacing: 0;
`;

export const MemberTableHead = styled.thead`
	border-bottom: 1px solid ${(p) => p.theme.gray[200]};
`;

export const MemberTableHeader = styled.th`
	text-align: left;
	padding: 12px 16px;
	font-weight: 600;
	color: ${(p) => p.theme.gray[600]};
	font-size: 12px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
`;

export const MemberTableBody = styled.tbody``;

export const MemberTableRow = styled.tr``;

export const MemberTableCell = styled.td`
	padding: 16px;
	border-bottom: 1px solid ${(p) => p.theme.gray[100]};
`;

export const MemberInfo = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const MemberAvatar = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${unthemed.gray[0]};
	font-weight: 600;
	font-size: 14px;
	flex-shrink: 0;
`;

export const MemberDetails = styled.div`
	display: flex;
	flex-direction: column;
`;

export const MemberName = styled.span`
	font-size: 14px;
	font-weight: 500;
	color: ${(p) => p.theme.gray[1000]};
`;

export const MemberEmail = styled.span`
	font-size: 12px;
	color: ${(p) => p.theme.gray[600]};
	margin-top: -6px;
`;

export const RemoveButton = styled.button<{ $disabled?: boolean }>`
	background-color: transparent;
	color: ${(p) => p.theme.gray[800]};
	border: none;
	border-radius: 4px;
	padding: 20px 34px;
	font-size: 13px;
	width: 60px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 500;
	letter-spacing: 0.02em;
	font-family: inherit;

	&:hover {
		background-color: ${(p) => (p.$disabled ? 'transparent' : p.theme.red[200])};
	}

	&:disabled {
		opacity: 0.5;
	}
`;

export const EmptyState = styled.div`
	padding: 24px;
	text-align: center;
	color: ${(p) => p.theme.gray[600]};
	font-size: 14px;
	background: ${(p) => p.theme.gray[100]};
	border-radius: 8px;
`;

export const LoadingState = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 60px;
`;

export const SupportNote = styled.p`
	font-size: 14px;
	color: ${(p) => p.theme.gray[600]};
	margin: 48px 0 0 0;
	line-height: 1.5;

	a {
		color: ${(p) => p.theme.blue[500]};
		text-decoration: none;

		&:hover {
			color: ${(p) => p.theme.blue[600]};
		}
	}
`;
